import { useCallback } from 'react'

import { DeepLinksEnum } from 'common/enums/DeepLink'
import { useHistory, useLocation } from 'react-router-dom'
import { TypesRoutes } from 'routes/mixedRoutes/types'
import useBoundState from 'store'
import { TabIdEnum } from 'common/enums/TabIdEnum'

export function PathQueryParams() {
  const location = useLocation()
  const history = useHistory()

  const getTickets = useBoundState((state) => state.getTickets)
  const setQueryParams = useBoundState((state) => state.setQueryParams)
  const setUtmCampaign = useBoundState((state) => state.setUtmCampaign)
  const setProbability = useBoundState((state) => state.setProbability)
  const setSelectedTab = useBoundState((state) => state.setSelectedTab)

  const whitelist = ['/']

  const handler = () => {
    if (whitelist.includes(location.pathname)) {
      const searchParams = new URLSearchParams(location.search)

      return setPathParams(location.pathname, searchParams)
    }

    return false
  }

  const handleTransmission = useCallback(
    (noTickets: boolean) => {
      noTickets
        ? getTickets({ history, pathname: TypesRoutes.LANDING_PAGE_HOME })
        : history.push(TypesRoutes.AFTER_SALES)
    },
    [history, getTickets],
  )

  const handleLandingPageTransmission = useCallback(() => {
    const { tickets } = useBoundState.getState()
    const totalRedemptionAmount = tickets?.totalRedemptionAmount ?? 0

    if (totalRedemptionAmount > 0) {
      history.push(TypesRoutes.REPURCHASE_INCENTIVE)
    } else {
      getTickets({ history, pathname: TypesRoutes.LANDING_PAGE_HOME })
    }
  }, [history, getTickets])

  const setPathParams = (pathname: string, params: URLSearchParams) => {
    let hasParams = false

    if (params.getAll.length > 0 && pathname === '/') {
      const urlParams = {
        url: params.get('url') || undefined,
        utm_campaign: params.get('utm_campaign') || undefined,
        probability: params.get('probability') || undefined,
      }

      if (urlParams.utm_campaign) {
        setUtmCampaign(urlParams.utm_campaign)
      }

      if (urlParams.probability) {
        setProbability(urlParams.probability)
      }

      if (urlParams.url && urlParams.url === DeepLinksEnum.AFTER_SALES) {
        getTickets({ onTransmission: handleLandingPageTransmission })

        setQueryParams(urlParams.url)
        hasParams = true
      }

      if (urlParams.url && urlParams.url === DeepLinksEnum.LANDING_PAGE) {
        getTickets({ onTransmission: handleLandingPageTransmission })

        setQueryParams(urlParams.url)
        hasParams = true
      }

      if (urlParams.url && urlParams.url === DeepLinksEnum.REDEMPTION) {
        getTickets({ onTransmission: handleTransmission })

        setSelectedTab(TabIdEnum.REDEMPTION)

        setQueryParams(urlParams.url)
        hasParams = true
      }
    }

    return hasParams
  }

  return handler
}
